module.exports = __webpack_public_path__ + "img/1@3x.95c98f74.png";